var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenuIconResourceActive = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 25,
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 4.5H4V7.86839H20V4.5Z",
  stroke: "#47E1E7",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 10.8154H4V14.1838H20V10.8154Z",
  stroke: "#47E1E7",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 17.1318H4V20.5002H20V17.1318Z",
  stroke: "#47E1E7",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenuIconResourceActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MenuIcon_Resource_active.32aa7a65a591333f210d8ca02d86fb00.svg";